import { render, staticRenderFns } from "./SettingsLsd.vue?vue&type=template&id=5be4dea8&scoped=true"
import script from "./SettingsLsd.vue?vue&type=script&lang=js"
export * from "./SettingsLsd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be4dea8",
  null
  
)

export default component.exports